module.exports = __webpack_public_path__ + "img/card+.bcbffa0e.svg";